import { useEffect } from "react"
import "../../styles/splash.scss"
import { Menu } from "../components/Menu"
import { Template } from "../components/Template"
import type { TemplateProps } from "../types"

export function SplashTemplate({ title, children }: TemplateProps) {
  useEffect(() => {
    document.title = title
  }, [title])

  return (
    <Template className="splashTemplate">
      <div className="splash">
        <article>{children}</article>
        <Menu />
      </div>
    </Template>
  )
}
